export const ENTITY_KINDS = {
  UPDATER: 'us',
  AGENT: 'agent',
  COBRANDED_AGENT: 'cobranded_agent',
};

export const ENTITY_NAMES = {
  UPDATER: 'Updater',
};
